import React from "react";
import { motion } from "framer-motion";

const Experience = () => {
  const experiences = [
    {
      title: "Senior Software Engineer & Team Lead",
      company: "Ringkas",
      period: "December 2023 - Present",
      location: "Ho Chi Minh City",
      description:
        "Led a cross-functional team of 6 engineers to develop and deploy a high-throughput Fintech software that improved end-to-end processing pipeline, increasing data handling capacity by more than 500% using Node.js, React.js, PostgreSQL, GraphQL and Lambda. Currently implementing AI-powered document processing and advisory systems using LangChain, LlamaIndex, and LlamaParse.",
      highlights: [
        "Regularly assess team performance and provide constructive feedback",
        "Implement AI document processing systems for intelligent data extraction and analysis",
        "Implement a process for code reviews to ensure high code quality",
        "Conduct daily stand-ups to track progress and identify blockers",
      ],
    },
    {
      title: "Software Engineer",
      company: "NFQ Asia",
      period: "April 2022 - December 2023",
      location: "Ho Chi Minh City",
      description:
        "Developed and deployed multiple web applications using HTML/CSS, JavaScript, React, and Node.js in an Agile environment. Achieved 25% reduction in development time and improved user experience by 37%.",
      highlights: [
        "Built Human Resources Management System for clients using Node.js, React.js, Redis, MySQL",
        "Integrated multiple APIs including Google API, HackerRank API, EFY System",
        "Developed client applications using Node.js, Vue.js, Content Stack",
      ],
    },
    {
      title: "Software Engineer",
      company: "Adtima-Zalo-VNG",
      period: "October 2020 - February 2022",
      location: "Ho Chi Minh City",
      description:
        "Developed campaign management systems and web applications for advertising platforms. Specialized in full-stack development using modern technologies.",
      highlights: [
        "Developed new campaign types using scan bill technology",
        "Built web applications for team and ad management",
        "Utilized Go, Node.js, Redis, MongoDB, Docker, and CI-CD",
      ],
    },
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Professional Experience
        </motion.h2>

        <div className="timeline">
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              className="timeline-item"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <div className="timeline-date">{exp.period}</div>
                <h3>{exp.title}</h3>
                <h4>
                  {exp.company} • {exp.location}
                </h4>
                <p>{exp.description}</p>
                <ul>
                  {exp.highlights.map((highlight, idx) => (
                    <li key={idx}>{highlight}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
